
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M24 19V8.99998C24 8.44998 23.55 7.99998 23 7.99998H17C16.45 7.99998 16 8.44998 16 8.99998V12.61L18 14.61V9.99998H22V17H20.39L23.32 19.93C23.71 19.8 24 19.44 24 19ZM21 5.99998C21.55 5.99998 22 5.54998 22 4.99998C22 4.44998 21.55 3.99998 21 3.99998H7.39L9.39 5.99998H21ZM1.36 2.20998C0.97 2.59998 0.97 3.22998 1.36 3.61998L2.47 4.72998C2.18 5.07998 2 5.51998 2 5.99998V17H1.5C0.67 17 0 17.67 0 18.5C0 19.33 0.67 20 1.5 20H17.73L19.37 21.64C19.76 22.03 20.39 22.03 20.78 21.64C21.17 21.25 21.17 20.62 20.78 20.23L2.77 2.20998C2.38 1.81998 1.75 1.81998 1.36 2.20998ZM4 17V6.26998L14.73 17H4Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-phonelink-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhonelinkOff

    ```js
    <b-new-b-icon-phonelink-off />
    ```
</docs>


